import gql from 'graphql-tag';

const StorySlideFragment = gql`
  fragment StorySlideFragment on StoriesSlidesModel {
    id
    story_id
    active
    type
    title
    text
    text_color
    button_link
    button_title
    button_title_color
    button_color
    delay
    file_link
    sort
    created
    alreadyWatched
    fileItem {
      cacheItem {
        filePath
      }
    }
  }
`;

const StoriesQuery = {
  getStories: gql`
    query getStories {
      getStories(imageSizeSlide: "h900", imageSizeStory: "h900") {
        id
        active
        title
        image
        label
        sort
        created
        fileItem {
          cacheItem {
            filePath
          }
        }
        slides {
          ...StorySlideFragment
        }
        alreadyWatched
      }
    }
    ${StorySlideFragment}
  `,
  addSlideToHistory: gql`
    mutation addSlideToHistory($slideId: Int!) {
      addSlideToHistory(slideId: $slideId)
    }
  `,
  getStoriesByPromotionId: gql`
    query getStoriesByPromotionId(
      $promotionId: Float!
      $imageSizeStory: String!
      $imageSizeSlide: String!
    ) {
      getStoriesByPromotionId(
        promotionId: $promotionId
        imageSizeStory: $imageSizeStory
        imageSizeSlide: $imageSizeSlide
      ) {
        id
        active
        title
        image
        label
        sort
        created
        fileItem {
          cacheItem {
            filePath
          }
        }
        slides {
          ...StorySlideFragment
        }
        alreadyWatched
      }
    }
    ${StorySlideFragment}
  `
};

export default StoriesQuery;
